<template>
    <div id="upgradeFunnelClub" class="modal inmodal fade modal-v5">
        <div class="modal-dialog modal-sm">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
                    <h4 class="modal-title">{{ t.title }}</h4>
                </div>
                <div class="modal-body">
                    <p class="content-text" v-html="t.message"></p>
                </div>
                <div class="modal-footer footer-btn">
                    <button class="checkout-button" @click.prevent="goToCheckout()">
                        <i class="fa fa-usd" aria-hidden="true"></i>
                        {{t.ok}}
                    </button>
                </div>
            </div>
        </div>
   </div>
</template>

<script>
export default {
    name: "upgrade-funnel-club",
    props: {
        view: {
            type: Object,
        }
    },
    data() {
        return {
            link: this.view.link,
            t: this.view.translations,
        }
    },
    methods: {
        goToCheckout: function(){
            window.open(this.link, '_blank');
            $("#upgradeFunnelClub").modal('hide');
        }
    },
    computed: {
    },
    watch: {
    }
}
</script>
<style lang="scss">
    .content-text{
        text-align: center;
        font-family: "Lato";
        font-weight: 600;
        color: #3d3d3d;
        padding: 0 0.5rem;
    }

    .checkout-button{
        font-size: 1.5vh!important;
        border: none;
        border-radius: 1vh;
        background-color: #0080fc;
        text-transform: uppercase;
        padding: 14px 60px!important;
        color: #fff;
    }
    .footer-btn{
        justify-content: center !important;
    }
</style>



// WEBPACK FOOTER //
// resources/office/js/components/dashboard-v5/modal/UpgradeFunnelClub.vue